/**
 * 보험금 청구 템플릿 STEP3 좌표 미리보기용 샘플 값.
 * 실제 PDF 렌더(ClaimFormRenderService)의 bindKey·valueType 규칙과 맞춘다.
 */
export function buildClaimTemplatePreviewValues(user) {
  const name = user?.name ? String(user.name) : '김설계'
  const phone = user?.phoneNumber ? String(user.phoneNumber) : '010-1234-5678'
  const da = new Date()
  const yyyy = String(da.getFullYear())
  const mm = String(da.getMonth() + 1).padStart(2, '0')
  const dd = String(da.getDate()).padStart(2, '0')

  return {
    __other: '표시 예시',
    actorName: name,
    loggedInUserName: name,
    actorPhone: phone,
    loggedInUserPhone: phone,
    actorPhone_1: phone.replace(/\D/g, '').slice(0, 3) || '010',
    actorPhone_2: phone.replace(/\D/g, '').slice(3, 7) || '1234',
    actorPhone_3: phone.replace(/\D/g, '').slice(7, 11) || '5678',
    loggedInUserPhone_1: phone.replace(/\D/g, '').slice(0, 3) || '010',
    loggedInUserPhone_2: phone.replace(/\D/g, '').slice(3, 7) || '1234',
    loggedInUserPhone_3: phone.replace(/\D/g, '').slice(7, 11) || '5678',
    customerName: '홍길동',
    customerBirthDate: '1990-01-15',
    customerPhone: '010-9876-5432',
    customerPhone_1: '010',
    customerPhone_2: '9876',
    customerPhone_3: '5432',
    customerResidentNumber: '900115-1234567',
    customerResidentNumber_1: '900115',
    customerResidentNumber_2: '1234567',
    customerAddress: '서울특별시 강남구 테헤란로 123',
    claimAmount: '150000',
    claimDate: `${yyyy}-${mm}-${dd}`,
    claimDateYear: yyyy,
    claimDateYear2: yyyy.slice(-2),
    claimDateYear20NN: yyyy,
    claimDateYearNN: yyyy.slice(-2),
    claimDateMonth: mm,
    claimDateDay: dd,
    accidentDate: `${yyyy}-03-10`,
    accidentDateYear: yyyy,
    accidentDateYear2: yyyy.slice(-2),
    accidentDateMonth: '03',
    accidentDateDay: '10',
    accidentDateHour: '14',
    accidentDateMinute: '30',
    claimSection: '실손의료비',
    claimItem: '입원',
    claimContent: '질병으로 인한 입원 치료를 받았습니다.',
    accidentDetails: '상세 경위 예시 텍스트입니다.',
    accidentLocation: '○○병원',
    hospitalName: '○○병원',
    diagnosis: '요추 염좌',
    accidentType: '질병',
    claimType: '입원, 통원',
    autoInsuranceProcessed: '아니오',
    autoInsuranceCompany: '',
    autoInsuranceContact: '',
    vehicleNumber: '12가3456',
    medicalBenefitRecipient: '예',
    medicalBenefitRecipient_Y: 'V',
    drivingLicense: '아니오',
    beneficiaryName: '홍길동',
    beneficiaryPhone: '010-9876-5432',
    beneficiaryPhone_1: '010',
    beneficiaryPhone_2: '9876',
    beneficiaryPhone_3: '5432',
    beneficiaryEmail: 'beneficiary@example.com',
    beneficiaryAddress: '서울특별시 강남구 테헤란로 123',
    beneficiaryResidentNo: '900115-1234567',
    beneficiaryResidentNumber: '900115-1234567',
    beneficiaryResidentNumber_1: '900115',
    beneficiaryResidentNumber_2: '1234567',
    beneficiarySameAsCustomer: '예',
    beneficiarySameAsContractHolder: '예',
    beneficiaryWorkplace: '○○회사',
    beneficiaryOccupation: '사무직',
    beneficiaryIdentityType: '주민등록증',
    beneficiaryResidentIdIssueDate: '2020-01-15',
    beneficiaryResidentIdIssueDateYear: '2020',
    beneficiaryResidentIdIssueDateYear2: '20',
    beneficiaryResidentIdIssueDateMonth: '01',
    beneficiaryResidentIdIssueDateDay: '15',
    beneficiaryResidentIdIssuer: '서울특별시 강남구청',
    beneficiaryDriverLicenseNumber: '서울-12-345678-90',
    beneficiaryDriverLicenseNumberRegion: '서울',
    beneficiaryDriverLicenseNumberSecond: '12',
    beneficiaryDriverLicenseNumberThird: '345678',
    beneficiaryDriverLicenseNumberFourth: '90',
    beneficiaryDriverLicenseSerialNumber: 'A123456',
    beneficiaryDriverLicenseIssueDate: '2020-01-15',
    beneficiaryDriverLicenseIssuer: '서울경찰청',
    contractHolderName: '홍길동',
    contractHolderResidentNumber: '900115-1234567',
    contractHolderResidentNumber_1: '900115',
    contractHolderResidentNumber_2: '1234567',
    contractHolderPhone: '010-9876-5432',
    contractHolderPhone_1: '010',
    contractHolderPhone_2: '9876',
    contractHolderPhone_3: '5432',
    contractHolderAddress: '서울특별시 강남구 테헤란로 123',
    virtualFaxNumber: '0500-1234-5678',
    postalFaxNumber: '우체국보험 서울지급센터 : 0505-005-1224',
    faxNumberSelection: '질병',
    injuryDiseaseTreatmentSupport: 'Y',
    groupActualMedicalInsurance: 'N',
    insuredJobDetail: '사무직 상세',
    identityType: '주민등록증',
    residentIdIssueDate: '2020-01-15',
    residentIdIssueDateYear: '2020',
    residentIdIssueDateYear2: '20',
    residentIdIssueDateMonth: '01',
    residentIdIssueDateDay: '15',
    residentIdIssuer: '서울특별시 강남구청',
    driverLicenseNumber: '서울-12-345678-90',
    driverLicenseNumberRegion: '서울',
    driverLicenseNumberSecond: '12',
    driverLicenseNumberThird: '345678',
    driverLicenseNumberFourth: '90',
    driverLicenseSerialNumber: 'A123456',
    driverLicenseIssueDate: '2020-01-15',
    driverLicenseIssuer: '서울경찰청',
    minorBeneficiary: '아니오',
    guardianSelection: '친권자 선택',
    guardianFatherName: '홍부',
    guardianFatherResidentNumber: '700101-1234567',
    guardianFatherResidentNumber_1: '700101',
    guardianFatherResidentNumber_2: '1234567',
    guardianFatherPhone: '010-1111-2222',
    guardianFatherPhone_1: '010',
    guardianFatherPhone_2: '1111',
    guardianFatherPhone_3: '2222',
    guardianMotherName: '홍모',
    guardianMotherResidentNumber: '720202-2345678',
    guardianMotherResidentNumber_1: '720202',
    guardianMotherResidentNumber_2: '2345678',
    guardianMotherPhone: '010-3333-4444',
    guardianMotherPhone_1: '010',
    guardianMotherPhone_2: '3333',
    guardianMotherPhone_3: '4444',
    petOwnerName: '홍길동',
    petOwnerResidentNumber: '900115-1234567',
    petOwnerResidentNumber_1: '900115',
    petOwnerResidentNumber_2: '1234567',
    petOwnerPhone: '010-9876-5432',
    petOwnerPhone_1: '010',
    petOwnerPhone_2: '9876',
    petOwnerPhone_3: '5432',
    petOwnerAddress: '서울특별시 강남구 테헤란로 123',
    petName: '초코',
    petBreed: '푸들',
    petGender: '암컷',
    petAge: '5세',
    petBirthDate: '2021-05-20',
    petBirthYear: '2021',
    petBirthMonth: '05',
    petBirthDay: '20',
    petColor: '갈색',
    petReceiptType: '신규',
    petDiagnosis: '슬개골 탈구',
    petAccidentCauseDetail: '산책 중 다리를 절어 내원했습니다.',
    petNarrativeWho: '보호자',
    petNarrativeWhen: '산책 중',
    petNarrativeWhere: '아파트 산책로',
    petNarrativeWhat: '반려견 다리',
    petNarrativeHow: '넘어진 뒤 절뚝거림',
    petNarrativeWhy: '미끄러운 노면',
    animalHospitalName: '초코동물병원',
    animalHospitalPhone: '02-123-4567',
    veterinarianName: '김수의',
    petDamageVictimPhone: '010-5555-6666',
    petDamageVictimName: '피해자',
    petDamageVictimAddress: '서울특별시 강남구 피해로 1',
    petDamageDescription: '대인 배상 손해',
    petDamageDetails: '치료비 및 파손 물품',
    petDamageVictimNameOrObject: '피해자 성명',
    petClaimCoverageMulti: '의료비, 배상책임',
    petDamageEtc: '기타 손해 예시',
    animalHospitalVetInfo: '동물병원명 / 담당 수의사',
    petTreatmentDateAndContent: '2026-03-10 진료 및 처치',
    petClaimCoverage: '의료비',
    petLossType: '대인',
    accidentLocationCity: '서울',
    accidentLocationDistrict: '강남구',
    accidentLocationTown: '역삼동',
    liabilityAccidentTypeDetail: '일상생활 중 발생한 배상책임 사고입니다.',
    accountHolderResidentNumber: '900115-1234567',
    accountHolderResidentNumber_1: '900115',
    accountHolderResidentNumber_2: '1234567',
    accountHolderRelation: '본인',
  }
}

/** 3종확인서 템플릿 미리보기용 */
export function buildAfterContractTemplatePreviewValues(user) {
  const name = user?.name ? String(user.name) : '김모집'
  const phone = user?.phoneNumber ? String(user.phoneNumber) : '010-2222-3333'
  const da = new Date()
  const yyyy = String(da.getFullYear())
  const mm = String(da.getMonth() + 1).padStart(2, '0')
  const dd = String(da.getDate()).padStart(2, '0')

  return {
    __other: '표시 예시',
    applicationNumber: 'APP-2026-001',
    policyNumber: 'POL-998877',
    designNumber: 'DES-1122',
    insuranceCompanyName: '○○생명',
    insurerName: '○○생명',
    productName: '종신보험 예시',
    contractorName: '홍길동',
    contractorBirthDate: '1985-06-20',
    contractorPhone: '010-1111-2222',
    insuredName: '홍길동',
    insuredBirthDate: '1985-06-20',
    insuredPhone: '010-1111-2222',
    plannerName: name,
    plannerPhone: phone,
    plannerOrgName: '○○GA 본부',
    printedAt: `${yyyy}-${mm}-${dd}`,
    printedAtYear: yyyy,
    printedAtYear2: yyyy.slice(-2),
    printedAtMonth: mm,
    printedAtDay: dd,
    documentDate: `${yyyy}-${mm}-${dd}`,
    documentDateYear: yyyy,
    documentDateYear2: yyyy.slice(-2),
    documentDateMonth: mm,
    documentDateDay: dd,
    contractDate: `${yyyy}-01-15`,
    contractDateYear: yyyy,
    contractDateMonth: '01',
    contractDateDay: '15',
    defaultStaticText: '고정 문구 예시',
  }
}
